import * as graphql from '@treams/treams-network';

import { IOption } from '../types/Option';

export interface IUserRecipient {
	userId: string;
	userData: graphql.User;
}

interface IEmailRecipient {
	name: string;
	email: string;
}

export type Recipient = IUserRecipient | IEmailRecipient;

export function isUserRecipient(toBeDetermined: Recipient): toBeDetermined is IUserRecipient {
	return (toBeDetermined as IUserRecipient).userId != null;
}

export type RecipientUserOption = IOption<graphql.User>;
type RecipientEmailOption = IOption<void>;
export type RecipientOption = RecipientUserOption | RecipientEmailOption;

export function isUserRecipientOption(
	toBeDetermined: RecipientOption,
): toBeDetermined is RecipientUserOption {
	return (toBeDetermined as RecipientUserOption).data != null;
}
